export default __webpack_public_path__ + "static/media/avatar2.e81efbfa.png";